import React from 'react';
import { useAuth } from "../Contexts/useAuth";

import { Navigate } from 'react-router-dom';

export default function AdminProtectedRoute({children}) {
    const {isAdmin} = useAuth();

    return isAdmin ? children : <Navigate to="/sign-in" state={{whoLogin: "admin"}} />
}
